module.exports = __webpack_public_path__ + "static/media/26-3.92bbb946.mp3";